import { render, staticRenderFns } from "./SliderThird.vue?vue&type=template&id=4d39c5c7&scoped=true&"
import script from "./SliderThird.vue?vue&type=script&lang=js&"
export * from "./SliderThird.vue?vue&type=script&lang=js&"
import style0 from "./SliderThird.vue?vue&type=style&index=0&id=4d39c5c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d39c5c7",
  null
  
)

export default component.exports